/* Bireafon — About page behaviour.
   Progressive enhancement only: the markup ships fully visible and the
   observer opts elements INTO the hidden state, so a no-JS or failed-load
   visitor sees a complete, static page rather than a blank one. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function activate(root) {
    var targets = root.querySelectorAll('[data-ba-anim]');
    if (!targets.length) return;

    if (REDUCED || !('IntersectionObserver' in window)) {
      // Nothing to arm: leave every element in its default visible state.
      return;
    }

    Array.prototype.forEach.call(targets, function (el) {
      el.setAttribute('data-anim', 'ready');
    });

    // Evidence that the observer is alive. Without it the safety net below
    // cannot tell "not scrolled there yet" from "callbacks never arrive".
    var delivered = false;

    var io = new IntersectionObserver(
      function (entries) {
        delivered = true;
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.setAttribute('data-anim', 'in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
    );

    // Observe synchronously. An earlier version waited two animation frames so
    // the transition would have a start value; but neither rAF nor the observer
    // callback runs while the document is hidden, so a page opened in a
    // background tab was armed to opacity 0 and never released. The observer
    // callback is async by definition, which is all the frame gap ever bought.
    Array.prototype.forEach.call(targets, function (el) {
      io.observe(el);
    });

    // Safety net: content must never be stuck invisible because an observer
    // did not deliver. Anything still armed but on screen after this is
    // disarmed outright rather than transitioned in — CSS transitions are
    // paused in a hidden document too, so promoting to "in" would leave the
    // element mid-fade at opacity 0. Dropping the attribute returns the
    // element to its plain, always-visible default state.
    window.setTimeout(function () {
      if (delivered) return;
      Array.prototype.forEach.call(targets, function (el) {
        if (el.getAttribute('data-anim') !== 'ready') return;
        el.removeAttribute('data-anim');
        io.unobserve(el);
      });
    }, 2500);
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ba-root]'), function (root) {
      if (root.dataset.baReady === '1') return;
      root.dataset.baReady = '1';
      activate(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section without a page load.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-ba-root]');
    if (root) {
      root.dataset.baReady = '1';
      activate(root);
    }
  });
})();
